import Fade from "react-reveal/Fade";

export default function SectionFour() {
  const kalangan = [
    {
      title: "Program Pemerintah",
      imglink: "imgsec4_1.png",
    },
    {
      title: "Produk Artis",
      imglink: "imgsec4_2.png",
    },
    {
      title: "Perusahaan",
      imglink: "imgsec4_3.png",
    },
    {
      title: "UMKM",
      imglink: "imgsec4_4.png",
    },
  ];

  return (
    <div className="text-white">
      <div className="md:flex flex-col md:mb-0 mb-20 mx-auto space-y-10">
        <Fade top>
          <h1 className="md:text-center md:text-4xl text-3xl font-bold uppercase">
            Sejak tahun 2020, Creatifa Studio telah dipercaya menangani desain
            dari berbagai kalangan, yakni:
          </h1>
        </Fade>
        <Fade bottom>
          <div className="grid md:grid-cols-4 grid-cols-2 gap-10">
            {kalangan.map((kal, i) => (
              <div key={i} className="flex flex-col space-y-3">
                <img
                  src={`/img/${kal.imglink}`}
                  className="w-full"
                  alt={kal.title}
                />
                <h2 className="font-medium text-center text-xl">{kal.title}</h2>
              </div>
            ))}
          </div>
        </Fade>
        <Fade bottom>
          <p className="font-bold text-xl text-center">
            Dan masih banyak lagi di seluruh indonesia dan internasional
          </p>
        </Fade>
      </div>
    </div>
  );
}
